// extracted by mini-css-extract-plugin
export var dividerLine = "_7s-3";
export var itemImage = "_7s-9";
export var lightDivider = "_7s-4";
export var modalContent = "_7s-5";
export var modalContentCompact = "_7s-6";
export var productCard = "_7s-a";
export var productImage = "_7s-b";
export var productImageCompact = "_7s-7";
export var productImagePlaceholder = "_7s-c";
export var productImagePlaceholderCompact = "_7s-8";
export var progressBarBackground = "_7s-1";
export var progressBarContainer = "_7s-0";
export var progressBarFill = "_7s-2";